import React from "react"
import { connect } from "react-redux"
import GenericDropdown from "../../../common/components/genericDropdown"
import AutomationCreationConsts from "../../automationCreationConsts"

class ValueTypeDropdown extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      menuOpen: false,
      menuAnchorEl: null,
      menuItems: AutomationCreationConsts.VALUE_TYPES,
      selectedIndexesArr: [0],
    }
  }

  handleMenuOpen = (event) => {
    this.setState({
      menuOpen: true,
      menuAnchorEl: event.currentTarget,
    })
  }

  handleMenuClose = () => {
    this.setState({
      menuOpen: false,
    })
  }

  handleMenuClick = (index) => {
    this.setState({
      selectedIndexesArr: index,
    })

    let selectedValueType = this.state.menuItems[index]
    this.props.handleSelect("selectedValueType", selectedValueType)

    this.handleMenuClose()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.automationDetailsState.selectedValueType !== this.props.automationDetailsState.selectedValueType) {
      const selectedIndex = this.state.menuItems.findIndex(
        (item) => item.valueType === this.props.automationDetailsState.selectedValueType.valueType
      )
      if (selectedIndex !== -1) {
        this.handleMenuClick([selectedIndex])
      }
    }
  }

  componentDidMount() {
    if (this.props.automationDetailsState.selectedValueType) {
      const selectedIndex = this.state.menuItems.findIndex(
        (item) => item.valueType === this.props.automationDetailsState.selectedValueType.valueType
      )
      if (selectedIndex !== -1) {
        this.handleMenuClick([selectedIndex])
      }
    }
  }

  render() {
    let buttonClassName = "creation-generic-dropdown-button value-type-button darker-text "

    return (
      <div className={"text-field rule-field"}>
        <div className="creation-generic-dropdown-label">Rule</div>
        <GenericDropdown
          header={this.state.menuItems[this.state.selectedIndexesArr[0]].name}
          selectOptionCallback={(index) => {
            this.handleMenuClick(index)
          }}
          options={this.state.menuItems}
          open={this.state.menuOpen}
          anchorEl={this.state.menuAnchorEl}
          selectedIndexes={this.state.selectedIndexesArr}
          openDropdownCallback={(event) => {
            this.handleMenuOpen(event)
          }}
          allowAutoSuggest={false}
          closeDropdownCallback={this.handleMenuClose}
          allowNoSelection={false}
          buttonClassName={buttonClassName}
          menuClassName={"value-type-dropdown-menu"}
        />
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {}
}

export default connect(mapStateToProps)(ValueTypeDropdown)
